/* eslint-disable react/jsx-filename-extension */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React, { Suspense } from 'react';
import { MainContainerLoader } from '../../authhome/Loader/ComponentLoader';
import { AET_ROUTES } from '../../../common/constants';
import IframeWrapper from './IframeWrapper';

export default {
  path: [
    AET_ROUTES.Iframe_DASHBOARD
  ],
  exact: true,
  services: [],
  stores: [],
  render: props => (
    <Suspense fallback={<MainContainerLoader />}>
      <IframeWrapper {...props} />
    </Suspense>
  )
};
